<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import '@/assets/scss/main.scss';

export default defineComponent({
  name: 'App'
});
</script>
